import { render, staticRenderFns } from "./HowItWorksBoxes.vue?vue&type=template&id=290456a8&scoped=true&"
var script = {}
import style0 from "./HowItWorksBoxes.vue?vue&type=style&index=0&id=290456a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290456a8",
  null
  
)

export default component.exports